<template>
  <div class="avatargame">
    <div :class="`load-box ${getLoadClass}`">
        <div class="load-head">Welcome to <br /> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; MOMOverse...</div>
    </div>

    <div class="game">
        <iframe 
            ref="avatargame"
            height="100%"
            width="100%"
            :src="iframeSrc" frameborder="0"
        />

        <div v-if="!inGame" @click="setInGame" class="game-mask"></div>
        <transition name="fade">
            <div v-if="!inGame&&doneInit" @click="setInGame" key="0" class="explore-btn">
                <div class="btn-3">Explore MOMOverse</div>
                <img class="clicker" src="@/assets/index/avatargame/clicker.png" />
            </div>
        </transition>
        <!-- src="./avatargame" frameborder="0" -->
    </div>

    <!-- <div :class="`avatar-bottom ${getBottomClass}`">
        <div class="bottom-box">
            <div class="left">
                <img class="avatar" src="@/assets/index/avatargame/avatar.png" alt="">
                <img class="slogan" src="@/assets/index/avatargame/slogan.png" alt="">
            </div>
            <div class="btn-1">
                Play Now
            </div>
        </div>
    </div> -->
  </div>
</template>

<script>
import { mapState } from "vuex";

const $ = window.$;

export default {
    data(){
        return {
            hideLoad : false,
            doneInit:false,
            // iframeSrc:`http://192.168.5.191:1250/`
            iframeSrc:`./avatargame`
        }
    },

    computed: {
        ...mapState({
            // 市值
            inGame: (state) => state.globalState.inGame,
        }),

        getBottomClass(){
            return this.inGame ? `hide-menu` : ``
        },

        getLoadClass(){
            // return this.hideLoad ? `` : ``
            return this.hideLoad ? `hide-load` : ``
        }
    },

    mounted(){
        window.addEventListener('message', (e)=>{
            const {from, action} = e.data;

            if(from == "avatargame") {
                switch(action) {
                    case "inGame" : 
                        this.setInGame(false);
                        break;
                    case "finishLoad" : 
                        this.hideLoad = true;
                        this.initGame();
                        break;
                    default:
                        break
                }
            }
            // if(from == "avatargame" && action == "finishLoad") {
            //     this.setInGame(false);
            // }
        });

        this.$root.eventHub.$on("amin-end", ()=>{
            let t = setTimeout(() => {
                this.doneInit = true;
                clearTimeout(t)
            }, 1500);

            this.$refs.avatargame.contentWindow.postMessage({
                    from: "mbox",
                    action:"startPlay",
                    value:null,
                },
                "*"
            );
        });

        // window.diu = (what)=>{
        //     this.$store.commit("globalState/setInGame", what)
        // }
    },
    
    methods:{
        setInGame(newInGame = true){
            const $body = $(document.getElementsByTagName('body'));

            if(newInGame){
                $("body,html").animate({scrollTop:0},500);

                $body.addClass('no-scroll');
            } else {
                $body.removeClass('no-scroll');
            }

            this.$store.commit("globalState/setInGame", newInGame);

            if(newInGame) {
                this.$refs.avatargame.contentWindow.postMessage({
                        from: "mbox",
                        action:"inGame",
                        value:{inGame:true},
                    },
                    "*"
                );
            }
        },
        initGame(){
            const inGame = this.inGame ? true : false;
            this.$refs.avatargame.contentWindow.postMessage({
                    from: "mbox",
                    action:"inGame",
                    value:{inGame},
                },
                "*"
            );
        }
    }
}
</script>

<style lang="less" scoped>
    .load-box{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .hide-load{
        animation: hideLoad 2s forwards;
    }

    .load-head{
        white-space: nowrap;

        font-size: 130px;
        line-height: 130px;
        background-image: url("../../assets/index/test/test1.png");
        background-clip: text; /* ! */
        color: transparent;    /* ! */

        font-family: Poppins-ex;
        animation: scrollingTxt 5s linear infinite;

        -webkit-text-stroke:1px black;
    }

    @keyframes hideLoad {
        0% {
            transform: translate(-50%, -50%) scale(1);
            opacity: 1;
        }
        25%{
            opacity: 0;
        }
        99% {
            transform: translate(-50%, -50%) scale(1.5);
            opacity: 0;
        }
        100% {
            transform: translate(-50%, -50%) scale(0);
            opacity: 0;
        }
    }

    .avatargame{
        width: 100vw;
        height: 100vh;
        position: relative;

        overflow: hidden;

        .game{
            width: 100%;
            height: 100%;

            .game-mask{
                position: absolute;
                top: 0;
                left: 0;

                width: 100%;
                height: 100%;
            }

            .explore-btn{
                position: absolute;
                left: 50%;
                bottom: 50px;
                transform: translate(-50%, 0);

                .clicker{
                    position: absolute;
                    right: -10%;
                    width: 30%;
                    top: 30%;

                    animation: scaleingB 5s linear infinite;
                }
            }
        }

        .avatar-bottom{
            // transition: all 0.8s cubic-bezier(0.68, -0.55, 0.27, 1.55);
            transition: all 0.8s;

            position: absolute;
            bottom: 0;

            background: url(../../assets/index/avatargame/bg.png) no-repeat;
            background-size: cover;
            background-position: center;

            width: 100%;
            height: 180px;

            .bottom-box{
                height: 100%;
                width: 70%;
                display: flex;
                margin: auto;

                align-items: center;
                justify-content: space-around;

                .left{
                    height: 100%;
                    display: flex;
                    align-items: flex-end;

                    .avatar{
                        height: 90%;
                        margin-right: 30px;
                    }

                    .slogan{
                        height: 80%;
                        margin-bottom: 3%;
                    }
                }
            }
        }

        .hide-menu{
            bottom: -180px;
        }
    }
</style>
